export const validations = { 
  required: 'Obrigatório',
  invalid_email: 'E-mail inválido',
  workout_description_or_exercise_required: 'Você precisa descrever as tarefas do treino ou escolher os exercícios',
  invalid_time: 'Este formato de tempo não é válido'
};